import { Button } from '@teliaee/design-system';
import { observer } from 'mobx-react';
import qs from 'qs';
import React from 'react';
import { ADD_EMAIL } from '../Routes';
import { AccountReturnParams } from '../pages/AccountPage';
import useStores from '../stores/UseStores';

interface AddEmailButtonProps {
  returnParams: AccountReturnParams;
}

const AddEmailButton = observer((props: AddEmailButtonProps): React.JSX.Element => {
  const { returnParams } = props;
  const {
    translateStore: { translate },
    uiStore: { hideNotices },
    addEmailStore: { setAddEmailModalState },
  } = useStores();
  const url = `${ADD_EMAIL}${qs.stringify(returnParams, { addQueryPrefix: true })}`;

  return (
    <Button
      iconLeft="#plus"
      type="expressive"
      isUnderlined={true}
      onClick={(event) => {
        event.preventDefault();
        setAddEmailModalState(true);
        hideNotices();
      }}
      text={translate('accountPage.addEmail')}
      url={url}
    />
  );
});

export default AddEmailButton;
